import {faIconCreator} from './fa-icon-creator';

export {getFileIcon} from './get-icon';
export {NotificationIcon} from './notification-icon';

export {ButtonIcon} from './button-icon';

export {LeadStatusIcon} from './lead-status-icon';
export type {Status} from './lead-status-icon';

export {MessengerColoredIcon} from './messenger-colored-icon';
export {InstagramColoredIcon} from './instagram-colored-icon';
export {FacebookColoredIcon} from './facebook-colored-icon';

export {EmailSequenceIcon} from './email-sequence-icon';

// 2025 navigation icons
export {NavIconAdministrationIcon} from './navigation/nav-icon-administration';
export {NavIconAutomationIcon} from './navigation/nav-icon-automation';
export {NavIconChatIcon} from './navigation/nav-icon-chat';
export {NavIconChevronLeftIcon} from './navigation/nav-icon-chevron-left';
export {NavIconChevronRightIcon} from './navigation/nav-icon-chevron-right';
export {NavIconConnectionsIcon} from './navigation/nav-icon-connections';
export {NavIconDashboardIcon} from './navigation/nav-icon-dashboard';
export {NavIconDataIcon} from './navigation/nav-icon-data';
export {NavIconEmailIcon} from './navigation/nav-icon-email';
export {NavIconEngagementIcon} from './navigation/nav-icon-engagement';
export {NavIconMarketingIcon} from './navigation/nav-icon-marketing';
export {NavIconOrganizationIcon} from './navigation/nav-icon-organization';
export {NavIconProspectorIcon} from './navigation/nav-icon-prospector';
export {NavIconQuotasIcon} from './navigation/nav-icon-quotas';
export {NavIconSalesIcon} from './navigation/nav-icon-sales';
export {NavIconSchedulerIcon} from './navigation/nav-icon-scheduler';
export {NavIconSettingsIcon} from './navigation/nav-icon-settings';
export {NavIconSettingsWrenchIcon} from './navigation/nav-icon-settings-wrench';
export {NavIconYourSettingsIcon} from './navigation/nav-icon-your-settings';
export {NavIconWebsiteIcon} from './navigation/nav-icon-website';
export {NavIconLogoutIcon} from './navigation/nav-icon-logout';

// SVG
export {AcceptedIcon} from './svg/accepted-icon';
export {AccountIcon} from './svg/account-icon';
export {AccountChildOverlayIcon} from './svg/account-child-overlay-icon';
export {AccountsCircleIcon} from './svg/accounts-circle-icon';
export {AccountParentIcon} from './svg/account-parent-icon';
export {AccountParentCircleIcon} from './svg/account-parent-circle-icon';
// @ts-expect-error
export {ActivitiesCircleIcon} from './svg/activities-circle-icon';
// @ts-expect-error
export {ActivityEmptyStateIcon} from './svg/activity-empty-state-icon';
// @ts-expect-error
export {ActivityErrorStateIcon} from './svg/activity-error-state-icon';
// @ts-expect-error
export {ActivityIcon} from './svg/activity-icon';
// @ts-expect-error
export {ActivityImportantIcon} from './svg/activity-important-icon';
// @ts-expect-error
export {ActivityMinimizeIcon} from './svg/activity-minimize-icon';
export {ActivityLogRegularAiIcon} from './svg/activity-log-regular-ai-icon';
// @ts-expect-error
export {AddIcon} from './svg/add-icon';
export {AddPersonRegularIcon} from './svg/add-person-regular-icon';
// @ts-expect-error
export {AddReactionIcon} from './svg/add-reaction-icon';
// @ts-expect-error
export {AdminLockIcon} from './svg/admin-lock-icon';
export {AdminDigestRegularAiIcon} from './svg/admin-digest-regular-ai-icon';
export {AircallIcon} from './svg/aircall-icon';
export {AircallRegularAiIcon} from './svg/aircall-regular-ai-icon';
export {AiSparkleNewIcon} from './svg/ai-sparkle-new-icon';
// @ts-expect-error
export {AlarmClockIcon} from './svg/alarm-clock-icon';
export {AddressCardIcon} from './svg/address-card-icon';
export {AgentsIcon} from './svg/agents-icon';
// @ts-expect-error
export {AlignCenterIcon} from './svg/align-center-icon';
// @ts-expect-error
export {AlignLeftIcon} from './svg/align-left-icon';
// @ts-expect-error
export {AlignRightIcon} from './svg/align-right-icon';
// @ts-expect-error
export {ArchiveIcon} from './svg/archive-icon';
export {ArchiveRegularIcon} from './svg/archive-regular-icon';
// @ts-expect-error
export {ArrowDownIcon} from './svg/arrow-down-icon';
export {ArrowDownThinIcon} from './svg/arrow-down-thin-icon';
export {ArrowDownUpRegularIcon} from './svg/arrow-down-up-regular-icon';
export {ArrowLeftIcon} from './svg/arrow-left-icon';
// @ts-expect-error
export {ArrowLeftRightIcon} from './svg/arrow-left-right-icon';
export {ArrowLeftThinIcon} from './svg/arrow-left-thin-icon';
// @ts-expect-error
export {ArrowRightIcon} from './svg/arrow-right-icon';
export {ArrowRightThinIcon} from './svg/arrow-right-thin-icon';
// @ts-expect-error
export {ArrowUpIcon} from './svg/arrow-up-icon';
// @ts-expect-error
export {ArrowsAscIcon} from './svg/arrows-asc-icon';
// @ts-expect-error
export {ArrowsDescIcon} from './svg/arrows-desc-icon';
export {ArrowsMergeRegularIcon} from './svg/arrows-merge-regular-icon';
// @ts-expect-error
export {ArrowUpDownIcon} from './svg/arrow-up-down-icon';
export {AttendeeCircleIcon} from './svg/attendee-circle-icon';
export {AttendeeSquareIcon} from './svg/attendee-square-icon';
export {AutoDistributionBoltIcon} from './svg/auto-distribution-bolt-icon';
// @ts-expect-error
export {AudienceIcon} from './svg/audience-icon';
export {AvatarBlueIcon} from './svg/avatar-blue-icon';
export {AvatarGreenIcon} from './svg/avatar-green-icon';
export {AvatarPurpleIcon} from './svg/avatar-purple-icon';
export {AvatarTealIcon} from './svg/avatar-teal-icon';
export {AvatarYellowIcon} from './svg/avatar-yellow-icon';
export {BellRegularIcon} from './svg/bell-regular-icon';
export {BinocularsRegularAiIcon} from './svg/binoculars-regular-ai-icon';
export {BranchRegularIcon} from './svg/branch-regular-icon';
export {BriefcaseRegularIcon} from './svg/briefcase-regular-icon';
export {BoardRegularIcon} from './svg/board-regular-icon';
export {BoltRegularIcon} from './svg/bolt-regular-icon';
export {BookIcon} from './svg/book-icon';
// @ts-expect-error
export {BookingIcon} from './svg/booking-icon';
export {BookRegularIcon} from './svg/book-regular-icon';
export {BoxRegularIcon} from './svg/box-regular-icon';
export {BoxesRegularIcon} from './svg/boxes-regular-icon';
export {BulletListRegularIcon} from './svg/bullet-list-regular-icon';
export {BusinessCardRegularIcon} from './svg/business-card-regular-icon';
// @ts-expect-error
export {BroadcastIcon} from './svg/broadcast-icon';
// @ts-expect-error
export {BrowserIcon} from './svg/browser-icon';
// @ts-expect-error
export {CalendarIcon} from './svg/calendar-icon';
// @ts-expect-error
export {CalendarFollowUpIcon} from './svg/calendar-follow-up-icon';
export {CalendarPenIcon} from './svg/calendar-pen-icon';
export {CalendarPenRegularReportIcon} from './svg/calendar-pen-regular-report-icon';
// @ts-expect-error
export {CalendarPreviousIcon} from './svg/calendar-previous-icon';
export {CalendarSquareRegularCheckIcon} from './svg/calendar-square-regular-check-icon';
export {CalendarRegularPenIcon} from './svg/calendar-regular-pen-icon';
export {CalendarRegularReportIcon} from './svg/calendar-regular-report-icon';
export {CalendarSquareRegularActivityIcon} from './svg/calendar-square-regular-activity-icon';
export {CalendarSquareRegularEventIcon} from './svg/calendar-square-regular-event-icon';
export {CalendarSquareRegularAgendaIcon} from './svg/calendar-square-regular-agenda-icon';
export {CalendarSquareRegularTypeIcon} from './svg/calendar-square-regular-type-icon';
export {CalendarToNutshellIcon} from './svg/calendar-to-nutshell-icon';
export {CalendarXIcon} from './svg/calendar-x-icon';
export {CallrailIcon} from './svg/callrail-icon';
export {CallrailRegularAiIcon} from './svg/callrail-regular-ai-icon';
// @ts-expect-error
export {CampaignIcon} from './svg/campaign-icon';
// @ts-expect-error
export {CancelIcon} from './svg/cancel-icon';
export {CancelCircleRegularIcon} from './svg/cancel-circle-regular-icon';
export {CancelRegularReportIcon} from './svg/cancel-regular-report-icon';
export {CardIcon} from './svg/card-icon';
export {CaretSolidDownIcon} from './svg/caret-solid-down-icon';
export {ChartLineConnectedRegularReportIcon} from './svg/chart-line-connected-regular-report-icon';
export {ChartLineRegularReportIcon} from './svg/chart-line-regular-report-icon';
export {ChatIcon} from './svg/chat-icon';
export {ChatBubbleRegularIcon} from './svg/chat-bubble-regular-icon';
export {ChatbotIcon} from './svg/chatbot-icon';
export {ChatbotRegularAiIcon} from './svg/chatbot-regular-ai-icon';
export {ChatbotRegularIcon} from './svg/chatbot-regular-icon';
export {ChatBubbleDoubleRegularIcon} from './svg/chat-bubble-double-regular-icon';
// @ts-expect-error
export {ChatMessageIcon} from './svg/chat-message-icon';
export {ChatRegularIcon} from './svg/chat-regular-icon';
export {ChatRegularOptionsIcon} from './svg/chat-regular-options-icon';
export {ChatRegularReportIcon} from './svg/chat-regular-report-icon';
export {ChartLineUpRegularIcon} from './svg/chart-line-up-regular-icon';
export {CheckboxIcon} from './svg/checkbox-icon';
// @ts-expect-error
export {CheckmarkIcon} from './svg/checkmark-icon';
export {CheckRegularReportIcon} from './svg/check-regular-report-icon';
export {CheckCircleSolidIcon} from './svg/check-circle-solid-icon';
export {CheckCircleRegularIcon} from './svg/check-circle-regular-icon';
export {CheckedCircleRegularIcon} from './svg/checked-circle-regular-icon';
export {ChevronDown} from './svg/chevron-down-icon';
export {ChevronLightRegularDown} from './svg/chevron-light-regular-down-icon';
export {ChevronRegularRightLeadReportIcon} from './svg/chevron-regular-right-lead-report-icon';
// @ts-expect-error
export {ChevronUp} from './svg/chevron-up-icon';
export {CircleDollarRegularIcon} from './svg/circle-dollar-regular-icon';
// @ts-expect-error
export {CircleMinusIcon} from './svg/circle-minus-icon';
export {CirclePlusRegularIcon} from './svg/circle-plus-regular-icon';
// @ts-expect-error
export {CirclePersonIcon} from './svg/circle-person-icon';
export {CircleWarningIcon} from './svg/circle-warning-icon';
// @ts-expect-error
export {ClipboardChecklistIcon} from './svg/clipboard-checklist-icon';
// @ts-expect-error
export {CloneIcon} from './svg/clone-icon';
// @ts-expect-error
export {CloseIcon} from './svg/close-icon';
export {CloseLightRegularIcon} from './svg/close-light-regular-icon';
export {CloseHeavyRegularIcon} from './svg/close-heavy-regular-icon';
export {ClockRegularIcon} from './svg/clock-regular-icon';
export {ClockArrowRegularIcon} from './svg/clock-arrow-regular-icon';
export {CloudSlashIcon} from './svg/cloud-slash-icon';
export {CloudUploadRegularIcon} from './svg/cloud-upload-regular-icon';
export {CodeIcon} from './svg/code-icon';
export {CoffeeRegularAiIcon} from './svg/coffee-regular-ai-icon';
// @ts-expect-error
export {CogIcon} from './svg/cog-icon';
export {CogRegularIcon} from './svg/cog-regular-icon';
export {CogRegularReportIcon} from './svg/cog-regular-report-icon';
// @ts-expect-error
export {CollapseIcon} from './svg/collapse-icon';
// @ts-expect-error
export {ColumnPickerIcon} from './svg/column-picker-icon';
// @ts-expect-error
export {ColumnsIcon} from './svg/columns-icon';
// @ts-expect-error
export {CommentIcon} from './svg/comment-icon';
export {ComputerMobileRegularIcon} from './svg/computer-mobile-regular-icon';
export {CommentSmileRegularIcon} from './svg/comment-smile-regular-icon';
export {CommentPencilRegularIcon} from './svg/comment-pencil-regular-icon';
export {ChatBubbleDotRegularIcon} from './svg/chat-bubble-dot-regular-icon';
export {ChatBubbleSlashRegularIcon} from './svg/chat-bubble-slash-regular-icon';
export {ChatBubbleQuestionRegularIcon} from './svg/chat-bubble-question-regular-icon';
// @ts-expect-error
export {CompanyIcon} from './svg/company-icon';
export {CompanyContactIcon} from './svg/company-contact-icon';
export {CompanyRegularIcon} from './svg/company-regular-icon';
export {CompanySearchRegularAiIcon} from './svg/company-search-regular-ai-icon';
// @ts-expect-error
export {CompanyTypeIcon} from './svg/company-type-icon';
// @ts-expect-error
export {CompassIcon} from './svg/compass-icon';
export {CompetitorRegularAiIcon} from './svg/competitor-regular-ai-icon';
// @ts-expect-error
export {CompetitorRegularIcon} from './svg/competitor-regular-icon';
// @ts-expect-error
export {ComingSoonIcon} from './svg/coming-soon-icon';
// @ts-expect-error
export {ConfirmIcon} from './svg/confirm-icon';
// @ts-expect-error
export {ConstantContactIcon} from './svg/constant-contact-icon';
// @ts-expect-error
export {ContactAssigneeIcon} from './svg/contact-assignee-icon';
export {ContactIcon} from './svg/contact-icon';
export {ContactsCircleIcon} from './svg/contacts-circle-icon';
// @ts-expect-error
export {CopyIcon} from './svg/copy-icon';
// @ts-expect-error
export {CopyRegularIcon} from './svg/copy-regular-icon';
export {CsvImportIcon} from './svg/csv-import-icon';
// @ts-expect-error
export {CtcKeypadIcon} from './svg/ctc-keypad-icon';
export {CursorRegularIcon} from './svg/cursor-regular-icon';
// @ts-expect-error
export {DeltaArrowDownIcon} from './svg/delta-arrow-down-icon';
// @ts-expect-error
export {DeltaArrowUpIcon} from './svg/delta-arrow-up-icon';
// @ts-expect-error
export {DesktopIcon} from './svg/desktop-icon';
export {DelayCircleIcon} from './svg/delay-circle';
// @ts-expect-error
export {DialpadIcon} from './svg/dialpad-icon';
export {DialpadRegularAiIcon} from './svg/dialpad-regular-ai-icon';
export {DocumentReadyIcon} from './svg/document-ready-icon';
// @ts-expect-error
export {DoorClosedIcon} from './svg/door-closed-icon';
// @ts-expect-error
export {DoorOpenIcon} from './svg/door-open-icon';
export {DoubleTickIcon} from './svg/double-tick-icon';
// @ts-expect-error
export {DownloadIcon} from './svg/download-icon'; // Use DownloadOutlineIcon instead
export {DownloadOutlineIcon} from './svg/download-outline-icon';
export {DraftIcon} from './svg/draft-icon';
// @ts-expect-error
export {DragHandleIcon} from './svg/drag-handle-icon';
export {DripsRegularIcon} from './svg/drips-regular-icon';
export {EditThickerIcon} from './svg/edit-thicker-icon';
// @ts-expect-error
export {EmailIcon} from './svg/email-icon';
// @ts-expect-error
export {EmailSeriesIcon} from './svg/email-series-icon';
// @ts-expect-error
export {EmptyFolderIcon} from './svg/empty-folder-icon';
export {EmptyInvoicesTableIcon} from './svg/empty-invoices-table';
export {EmptyQuotesTableIcon} from './svg/empty-quotes-table';
export {EngagementIcon} from './svg/engagement-icon';
// @ts-expect-error
export {EnvelopeIcon} from './svg/envelope-icon'; // Use EnvelopeRegularIcon instead
export {EnvelopeRegularIcon} from './svg/envelope-regular-icon';
export {EnvelopeOpenRegularTemplateIcon} from './svg/envelope-open-regular-template-icon';
export {EnvelopeOpenSolidTemplateIcon} from './svg/envelope-open-solid-template-icon';
// @ts-expect-error
export {EnvelopeOpenTextIcon} from './svg/envelope-open-text-icon';
export {EnvelopeRegularReportIcon} from './svg/envelope-regular-report-icon';
export {EnvelopeRegularUserIcon} from './svg/envelope-regular-user-icon';
export {EnvelopesRegularAiIcon} from './svg/envelopes-regular-ai-icon';
export {EnvelopesRegularIcon} from './svg/envelopes-regular-icon';
export {EraserIcon} from './svg/eraser-icon';
// @ts-expect-error
export {ExCircleIcon} from './svg/ex-circle-icon';
// @ts-expect-error
export {ExpandIcon} from './svg/expand-icon';
// @ts-expect-error
export {ExploreIcon} from './svg/explore-icon';
export {ExternalArrowRegularIcon} from './svg/external-arrow-regular-icon';
// @ts-expect-error
export {ExternalLinkIcon} from './svg/external-link-icon'; // Use ExternalArrowRegularIcon instead
// @ts-expect-error
export {EyeIcon} from './svg/eye-icon'; // Use EyeRegularIcon instead
export {EyeRegularIcon} from './svg/eye-regular-icon';
// @ts-expect-error
export {EyeSlashIcon} from './svg/eye-slash-icon';
export {EyeClosedIcon} from './svg/eye-closed-icon';
export {FileAudioIcon} from './svg/file-audio-icon';
export {FileAudioRegularIcon} from './svg/file-audio-regular-icon';
export {FileExcelIcon} from './svg/file-excel-icon';
export {FileIcon} from './svg/file-icon';
export {FileImageIcon} from './svg/file-image-icon';
export {FilePdfIcon} from './svg/file-pdf-icon';
export {FilePowerpointIcon} from './svg/file-powerpoint-icon';
export {FileTextIcon} from './svg/file-text-icon';
export {FileTextRegularIcon} from './svg/file-text-regular-icon';
export {FileUploadIcon} from './svg/file-upload-icon';
export {FileVideoIcon} from './svg/file-video-icon';
export {FileWordIcon} from './svg/file-word-icon';
export {FileZipIcon} from './svg/file-zip-icon';
// @ts-expect-error
export {FilterIcon} from './svg/filter-icon';
export {FilterListRegularIcon} from './svg/filter-list-regular-icon';
export {FilterRegularIcon} from './svg/filter-regular-icon';
export {FilterRegularReportIcon} from './svg/filter-regular-report-icon';
export {FireSolidIcon} from './svg/fire-solid-icon';
export {FlagIcon} from './svg/flag-icon';
export {FlagTriangleRegularIcon} from './svg/flag-triangle-regular-icon';
export {FlameIcon} from './svg/flame-icon';
// @ts-expect-error
export {FolderIcon} from './svg/folder-icon';
export {FormRegularCheckIcon} from './svg/form-regular-check-icon';
// @ts-expect-error
export {FxIcon} from './svg/fx-icon';
// @ts-expect-error
export {ConnectedFormsIcon} from './svg/connected-forms-icon';
// @ts-expect-error
export {FrownyIcon} from './svg/frowny-icon';
export {GlobeAmericaRegularIcon} from './svg/globe-america-regular-icon';
export {GlobeRegularSearchIcon} from './svg/globe-regular-search-icon';
export {GlobeDomainRegularIcon} from './svg/globe-domain-regular-icon';
export {GlossaryIcon} from './svg/glossary-icon';
export {GlossaryBookmarkIcon} from './svg/glossary-bookmark-icon';
// @ts-expect-error
export {GoalActivityLoggedIcon} from './svg/goal-activity-logged-icon';
export {GoalAudienceIcon} from './svg/goal-audience-icon';
// @ts-expect-error
export {GoalClickIcon} from './svg/goal-click-icon';
// @ts-expect-error
export {GoalEmailIcon} from './svg/goal-email-icon';
// @ts-expect-error
export {GoalInvoiceIcon} from './svg/goal-invoice-icon';
// @ts-expect-error
export {GoalLeadClosedIcon} from './svg/goal-lead-closed-icon';
// @ts-expect-error
export {GoalLeadCreatedIcon} from './svg/goal-lead-created-icon';
// @ts-expect-error
export {GoalLeadFieldsIcon} from './svg/goal-lead-fields-icon';
// @ts-expect-error
export {GoalLeadInfoIcon} from './svg/goal-lead-info-icon';
export {GoalLeadStageIcon} from './svg/goal-lead-stage-icon';
// @ts-expect-error
export {GoalLeadValueIcon} from './svg/goal-lead-value-icon';
// @ts-expect-error
export {GoalQuoteIcon} from './svg/goal-quote-icon';
// @ts-expect-error
export {GoalTagIcon} from './svg/goal-tag-icon';
export {GoogleCalendarIcon} from './svg/google-calendar-icon';
export {GoogleCalendarRegularIcon} from './svg/google-calendar-regular-icon';
export {GmailRegularIcon} from './svg/gmail-regular-icon';
export {MicrosoftTeamsRegularIcon} from './svg/microsoft-teams-regular-icon';
export {MicrosoftOutlookRegularIcon} from './svg/microsoft-outlook-regular-icon';
export {Microsoft365RegularIcon} from './svg/microsoft-365-regular-icon';
export {GoogleCalendarToNutshellIcon} from './svg/google-calendar-to-nutshell-icon';
export {GoogleMeetIcon} from './svg/google-meet-icon';
export {GoogleMeetRegularIcon} from './svg/google-meet-regular-icon';
export {GoogleRegularAiIcon} from './svg/google-regular-ai-icon';
export {HalfAndHalfIcon} from './svg/half-and-half-icon';
export {HashIcon} from './svg/hash-icon';
export {HashtagRegularIcon} from './svg/hashtag-regular-icon';
export {HeartIcon} from './svg/heart-icon';
export {HierarchyRegularIcon} from './svg/hierarchy-regular-icon';
export {HomeIcon} from './svg/home-icon';
export {H1Icon} from './svg/h1-icon';
export {H2Icon} from './svg/h2-icon';
// @ts-expect-error
export {HeaderIcon} from './svg/header-icon';
// @ts-expect-error
export {HorizontalChartIcon} from './svg/horizontal-chart-icon';
// @ts-expect-error
export {HourglassEndIcon} from './svg/hourglass-end-icon';
// @ts-expect-error
export {HourglassHalfIcon} from './svg/hourglass-half-icon';
export {HourglassRegularIcon} from './svg/hourglass-regular-icon';
// @ts-expect-error
export {HourglassStartIcon} from './svg/hourglass-start-icon';
// @ts-expect-error
export {HtmlAttachmentIcon} from './svg/html-attachment-icon';
// @ts-expect-error
export {HtmlBoldIcon} from './svg/html-bold-icon';
// @ts-expect-error
export {HtmlImageIcon} from './svg/html-image-icon';
// @ts-expect-error
export {HtmlItalicIcon} from './svg/html-italic-icon';
export {HtmlLinkIcon} from './svg/html-link-icon';
// @ts-expect-error
export {HtmlListIcon} from './svg/html-list-icon';
// @ts-expect-error
export {HtmlUnderlineIcon} from './svg/html-underline-icon';
// @ts-expect-error
export {ImportIcon} from './svg/icon-import';
// @ts-expect-error
export {InboundArrowIcon} from './svg/inbound-arrow-icon';
// @ts-expect-error
export {InboundCallIcon} from './svg/inbound-call-icon';
// @ts-expect-error
export {IndustryIcon} from './svg/industry-icon';
export {IndustryRegularIcon} from './svg/industry-regular-icon';
export {InfoIcon} from './svg/info-icon';
export {InfoCircleRegularIcon} from './svg/info-circle-regular-icon';
export {InfoSquareIcon} from './svg/info-square-icon';
export {InstagramIcon} from './svg/instagram-icon';
export {InvoiceIcon} from './svg/invoice-icon';
export {InvoiceRegularDiagonalIcon} from './svg/invoice-regular-diagonal-icon';
export {KebabRegularIcon} from './svg/kebab-regular-icon';
export {KeyboardIcon} from './svg/keyboard-icon';
export {KixieIcon} from './svg/kixie-icon';
// @ts-expect-error
export {ReportsIcon} from './svg/reports-icon';
export {LayoutRegularIcon} from './svg/layout-regular-icon';
export {LeadChevronRegularIcon} from './svg/lead-chevron-regular-icon';
export {LeadIconChevron} from './svg/lead-icon-chevron';
export {LeadIcon} from './svg/lead-icon';
// @ts-expect-error
export {LeadCancelledIcon} from './svg/lead-cancelled-icon'; // Use CancelCircleRegularIcon instead
// @ts-expect-error
export {LeadLostIcon} from './svg/lead-lost-icon';
// @ts-expect-error
export {LeadPendingIcon} from './svg/lead-pending-icon';
export {LeadSearchRegularAiIcon} from './svg/lead-search-regular-ai-icon';
export {LeadsCircleIcon} from './svg/leads-circle-icon';
export {LeadResearcherIcon} from './svg/lead-researcher-icon';
// @ts-expect-error
export {LightbulbBrightIcon} from './svg/lightbulb-bright-icon';
// @ts-expect-error
export {LightbulbDimIcon} from './svg/lightbulb-dim-icon';
export {LightbulbRegularIcon} from './svg/lightbulb-regular-icon';
export {LinesLongRegularIcon} from './svg/lines-long-regular-icon';
// @ts-expect-error
export {LineVerticalIcon} from './svg/line-vertical-icon';
// @ts-expect-error
export {LinkClickIcon} from './svg/link-click-icon';
// @ts-expect-error
export {LinkedInIcon} from './svg/linked-in-icon';
// @ts-expect-error
export {ListIcon} from './svg/list-icon';
// @ts-expect-error
export {LoadingIcon} from './svg/loading-icon';
export {LocationPinIcon} from './svg/location-pin-icon';
export {LocationPinRegularIcon} from './svg/location-pin-regular-icon';
// @ts-expect-error
export {LockedIcon} from './svg/locked-icon';
export {LockRegularIcon} from './svg/lock-regular-icon';
export {LongTextIcon} from './svg/long-text-icon';
// @ts-expect-error
export {MagicIcon} from './svg/magic-icon';
// @ts-expect-error
export {MagnifyingGlassDollarIcon} from './svg/magnifying-glass-dollar-icon';
// @ts-expect-error
export {MagnifyingGlassChartIcon} from './svg/magnifying-glass-chart-icon';
// @ts-expect-error
export {MailchimpIcon} from './svg/mailchimp-icon';
export {MailerRegularAiIcon} from './svg/mailer-regular-ai-icon';
// @ts-expect-error
export {MapPinIcon} from './svg/map-pin-icon';
export {MarketingAutomationIcon} from './svg/marketing-automation-icon';
// @ts-expect-error
export {McpLogoIcon} from './svg/mcp-logo-icon';
export {McpRegularAiIcon} from './svg/mcp-regular-ai-icon';
export {MedalRegularIcon} from './svg/medal-regular-icon';
// @ts-expect-error
export {MemoIcon} from './svg/memo-icon';
export {MegaphoneRegularIcon} from './svg/megaphone-regular-icon';
// @ts-expect-error
export {MeetingIcon} from './svg/meeting-icon';
// @ts-expect-error
export {MessagesDollarIcon} from './svg/messages-dollar-icon';
// @ts-expect-error
export {MessagesIcon} from './svg/messages-icon';
export {MessageIcon} from './svg/message-icon';
export {MessageIconSolid} from './svg/message-icon-solid';
export {MessengerIcon} from './svg/messenger-icon';
// @ts-expect-error
export {MicrophoneIcon} from './svg/microphone-icon';
export {MicrophoneRegularIcon} from './svg/microphone-regular-icon';
export {MicrosoftTeamsRegularAiIcon} from './svg/microsoft-teams-regular-ai-icon';
// @ts-expect-error
export {MicrosoftTeamsIcon} from './svg/microsoft-teams-icon';
// @ts-expect-error
export {MinusIcon} from './svg/minus-icon';
export {MobilePhoneRegularIcon} from './svg/mobile-phone-regular-icon';
// @ts-expect-error
export {MultiplePipelineIcon} from './svg/multiple-pipeline-icon';
export {NameIcon} from './svg/name-icon';
// @ts-expect-error
export {NextStepIcon} from './svg/next-step-icon';
// @ts-expect-error
export {NewsletterIcon} from './svg/newsletter-icon';
// @ts-expect-error
export {NewTimelineIcon} from './svg/new-timeline-icon';
// @ts-expect-error
export {NoteIcon} from './svg/note-icon'; // Use NoteRegularIcon instead
export {NotePencilRegularIcon} from './svg/note-pencil-regular-icon';
export {NoteRegularAiIcon} from './svg/note-regular-ai-icon';
export {NoteRegularIcon} from './svg/note-regular-icon';
export {NotetakerIcon} from './svg/notetaker-icon';
export {NotSyncedIcon} from './svg/not-synced-icon';
export {NutshellToCalendarIcon} from './svg/nutshell-to-calendar-icon';
export {NutshellToGoogleCalendarIcon} from './svg/nutshell-to-google-calendar-icon';
export {NutshellToOffice365Icon} from './svg/nutshell-to-office-365-icon';
// @ts-expect-error
export {NutshellLogoMarkIcon} from './svg/nutshell-logo-mark-icon';
// @ts-expect-error
export {NutshellSpookyLogoMarkIcon} from './svg/nutshell-spooky-logo-mark-icon';
export {Office365ToNutshellIcon} from './svg/office-365-to-nutshell-icon';
// @ts-expect-error
export {OnDemandReportsIcon} from './svg/on-demand-reports-icon';
// @ts-expect-error
export {OpenIcon} from './svg/open-icon';
// @ts-expect-error
export {OutboundArrowIcon} from './svg/outbound-arrow-icon';
// @ts-expect-error
export {OutboundCallIcon} from './svg/outbound-call-icon';
export {OutlookCalendarIcon} from './svg/outlook-calendar-icon';
// @ts-expect-error
export {OutreachIcon} from './svg/outreach-icon';
export {OverviewRegularAiIcon} from './svg/overview-regular-ai-icon';
export {PaletteRegularIcon} from './svg/palette-regular-icon';
export {PandadocIcon} from './svg/pandadoc-icon';
export {ParentCompanyIcon} from './svg/parent-company-icon';
// @ts-expect-error
export {PauseCircleIcon} from './svg/pause-circle-icon';
// @ts-expect-error
export {PauseIcon} from './svg/pause-icon';
export {LocationPinCircleSolidIcon} from './svg/location-pin-circle-solid-icon';
export {LocationPinSolidIcon} from './svg/location-pin-solid-icon';
// @ts-expect-error
export {PeepsBookIcon} from './svg/peeps-book';
export {PencilOutlineIcon} from './svg/pencil-outline-icon';
// @ts-expect-error
export {PencilRegularRenameIcon} from './svg/pencil-regular-rename-icon';
// @ts-expect-error
export {PencilToPaperIcon} from './svg/pencil-to-paper-icon';
export {PenRulerRegularIcon} from './svg/pen-ruler-regular-icon';
export {PeopleRegularIcon} from './svg/people-regular-icon';
// @ts-expect-error
export {PersonCheckIcon} from './svg/person-check-icon';
export {PersonRoundRegularIcon} from './svg/person-round-regular-icon';
export {PersonSearchRegularAiIcon} from './svg/person-search-regular-ai-icon';
export {PersonSquareRegularIcon} from './svg/person-square-regular-icon';
export {PersonWarningIcon} from './svg/person-warning-icon';
export {PersonRegularSearchIcon} from './svg/person-regular-search-icon';
export {PeopleRoofRegularIcon} from './svg/people-roof-regular-icon';
// @ts-expect-error
export {PhoneCallIcon} from './svg/phone-call-icon'; // Use PhoneRegularIcon instead
export {PhoneRegularIcon} from './svg/phone-regular-icon';
export {PhoneRegularAiIcon} from './svg/phone-regular-ai-icon';
export {PiechartRegularAiIcon} from './svg/piechart-regular-ai-icon';
// @ts-expect-error
export {PinIcon} from './svg/pin-icon';
export {PipelineRegularAiIcon} from './svg/pipeline-regular-ai-icon';
export {PipelineRegularIcon} from './svg/pipeline-regular-icon';
// @ts-expect-error
export {PlantBigFilledIcon} from './svg/plant-big-filled-icon';
// @ts-expect-error
export {PlantBigOutlinedIcon} from './svg/plant-big-outlined-icon';
// @ts-expect-error
export {PlantMediumFilledIcon} from './svg/plant-medium-filled-icon';
// @ts-expect-error
export {PlantMediumOutlinedIcon} from './svg/plant-medium-outlined-icon';
// @ts-expect-error
export {PlantSmallFilledIcon} from './svg/plant-small-filled-icon';
// @ts-expect-error
export {PlantSmallOutlinedIcon} from './svg/plant-small-outlined-icon';
// @ts-expect-error
export {PlayButtonIcon} from './svg/play-button-icon';
export {PlayCircleRegularIcon} from './svg/play-circle-regular-icon';
export {PlayDoubleIcon} from './svg/play-double-icon';
export {PlayRoundedIcon} from './svg/play-rounded-icon';
// @ts-expect-error
export {PlusThinIcon} from './svg/plus-thin-icon';
// @ts-expect-error
export {ProBadgeIcon} from './svg/pro-badge';
export {ProductIcon} from './svg/product-icon'; // Use BoxRegularIcon instead
export {ProductImportIcon} from './svg/product-import-icon';
export {ProductReportIcon} from './svg/product-report-icon';
export {ProspectorIcon} from './svg/prospector-icon';
export {PuzzleIcon} from './svg/puzzle-icon';
// @ts-expect-error
export {QRCodeIcon} from './svg/qr-code-icon';
// @ts-expect-error
export {QuotaReachedIcon} from './svg/quota-reached-icon';
export {QuoteIcon} from './svg/quote-icon';
export {RadioIcon} from './svg/radio-icon';
export {InvoiceRegularIcon} from './svg/invoice-regular-icon';
// @ts-expect-error
export {ReplyAllIcon} from './svg/reply-all-icon';
export {ReplyArrowRegularAiIcon} from './svg/reply-arrow-regular-ai-icon';
// @ts-expect-error
export {ReplyClockIcon} from './svg/reply-clock-icon';
// @ts-expect-error
export {ReplyIcon} from './svg/reply-icon';
// @ts-expect-error
export {RetiringIcon} from './svg/retiring-icon';
// @ts-expect-error
export {RetryRegularIcon} from './svg/retry-regular-icon';
export {ReturnIcon} from './svg/return-icon';
// @ts-expect-error
export {RevenueIcon} from './svg/revenue-icon';
// @ts-expect-error
export {RingcentralIcon} from './svg/ringcentral-icon';
export {RingcentralRegularAiIcon} from './svg/ringcentral-regular-ai-icon';
// @ts-expect-error
export {RowsIcon} from './svg/rows-icon';
export {RobotIcon} from './svg/robot-icon';
export {QuoteRegularIcon} from './svg/quote-regular-icon';
export {SalesBubbleRegularAiIcon} from './svg/sales-bubble-regular-ai-icon';
export {SavingIcon} from './svg/saving-icon';
// @ts-expect-error
export {SchedulerIcon} from './svg/scheduler-icon';
export {SearchRegularIcon} from './svg/search-regular-icon';
// @ts-expect-error
export {SentEmailIcon} from './svg/sent-email-icon';
export {SearchBarsRegularAiIcon} from './svg/search-bars-regular-ai-icon';
export {SearchDollarRegularAiIcon} from './svg/search-dollar-regular-ai-icon';
// @ts-expect-error
export {SendIcon} from './svg/send-icon';
export {SelectMultiIcon} from './svg/select-multi-icon';
export {ShareArrowRegularIcon} from './svg/share-arrow-regular-icon';
export {ShortTextIcon} from './svg/short-text-icon';
// @ts-expect-error
export {SidebarIconAccountsIcon} from './svg/sidebar-icon-accounts';
// @ts-expect-error
export {SidebarIconContactsIcon} from './svg/sidebar-icon-contacts';
// @ts-expect-error
export {SidebarIconDashboardIcon} from './svg/sidebar-icon-dashboard';
// @ts-expect-error
export {SidebarIconHelpIcon} from './svg/sidebar-icon-help';
export {SidebarIconLogoutIcon} from './svg/sidebar-icon-logout';
// @ts-expect-error
export {SidebarIconNotificationsIcon} from './svg/sidebar-icon-notifications';
// @ts-expect-error
export {SidebarIconOnboardingIcon} from './svg/sidebar-icon-onboarding';
// @ts-expect-error
export {SidebarIconReportsIcon} from './svg/sidebar-icon-reports';
// @ts-expect-error
export {SidebarIconReportsIconOld} from './svg/sidebar-icon-reports-old';
// @ts-expect-error
export {SidebarIconSearchIcon} from './svg/sidebar-icon-search';
// @ts-expect-error
export {SidebarIconSetupIcon} from './svg/sidebar-icon-setup';
// @ts-expect-error
export {SiteGlobeIcon} from './svg/site-globe-icon';
export {SkipIcon} from './svg/skip-icon';
export {SkipArrowIcon} from './svg/skip-arrow-icon';
// @ts-expect-error
export {SlackIcon} from './svg/slack-icon';
export {SmsIcon} from './svg/sms-icon';
// @ts-expect-error
export {SmsBroadcastIcon} from './svg/sms-broadcast-icon';
// @ts-expect-error
export {SolidClockIcon} from './svg/solid-clock-icon';
// @ts-expect-error
export {SolidInfoIcon} from './svg/solid-info-icon';
export {SolidMessageCircleIcon} from './svg/solid-message-circle-icon';
export {SortIcon} from './svg/sort-icon';
// @ts-expect-error
export {SortDownIcon} from './svg/sort-down-icon';
export {SourceIcon} from './svg/source-icon';
export {SourcesIcon} from './svg/sources-icon';
export {SquareArrowRightRegularIcon} from './svg/square-arrow-right-regular-icon';
export {SquareArrowUpRightIcon} from './svg/square-arrow-up-right-icon';
export {SquareCheckRegularIcon} from './svg/square-check-regular-icon';
// @ts-expect-error
export {StageIcon} from './svg/stage-icon';
export {StageGoalIcon} from './svg/stage-goal-icon';
export {StarRegularIcon} from './svg/star-regular-icon';
export {StarRegularReportIcon} from './svg/star-regular-report-icon';
// @ts-expect-error
export {StepIcon} from './svg/step-icon';
// @ts-expect-error
export {StopCircleIcon} from './svg/stop-circle-icon';
// @ts-expect-error
export {StopIcon} from './svg/stop-icon';
export {SquircleZoomRegularIcon} from './svg/squircle-zoom-regular-icon';
// @ts-expect-error
export {SubheaderIcon} from './svg/subheader-icon';
export {SuccessMessageIcon} from './svg/success-message-icon';
export {SyncRegularIcon} from './svg/sync-regular-icon';
// @ts-expect-error
export {TabletIcon} from './svg/tablet-icon';
// @ts-expect-error
export {TagIcon} from './svg/tag-icon';
export {TagRegularDiagonalIcon} from './svg/tag-regular-diagonal-icon';
// @ts-expect-error
export {TagsIcon} from './svg/tags-icon';
export {TagRegularDiagonalReportIcon} from './svg/tag-regular-diagonal-report-icon';
export {TargetArrowIcon} from './svg/target-arrow-icon';
export {TargetRegularIcon} from './svg/target-regular-icon';
// @ts-expect-error
export {TaskIcon} from './svg/task-icon';
export {TaskTickOutlineIcon} from './svg/task-tick-outline';
export {TaskTickCompleteIcon} from './svg/task-tick-complete';
// @ts-expect-error
export {TeamIcon} from './svg/team-icon';
export {TeamReportRegularAiIcon} from './svg/team-report-regular-ai-icon';
// @ts-expect-error
export {TemplateIcon} from './svg/template-icon';
// @ts-expect-error
export {TerritoryIcon} from './svg/territory-icon';
export {TextBlockIcon} from './svg/text-block-icon';
// @ts-expect-error
export {TextIcon} from './svg/text-icon';
export {TextRegularAiIcon} from './svg/text-regular-ai-icon';
// @ts-expect-error
export {ThumbsDownIcon} from './svg/thumbs-down-icon';
export {ThumbsDownRegularIcon} from './svg/thumbs-down-regular-icon';
// @ts-expect-error
export {ThumbsUpIcon} from './svg/thumbs-up-icon';
export {ThumbsUpRegularIcon} from './svg/thumbs-up-regular-icon';
// @ts-expect-error
export {TickCircleIcon} from './svg/tick-circle-icon';
export {TickCircleOutlineIcon} from './svg/tick-circle-outline-icon'; // Use TaskTickOutlineIcon instead
// @ts-expect-error
export {TicketIcon} from './svg/ticket-icon';
export {TimelineArrowRegularIcon} from './svg/timeline-arrow-regular-icon';
export {TimelineRegularIcon} from './svg/timeline-regular-icon';
export {TimelineRegularAiIcon} from './svg/timeline-regular-ai-icon';
// @ts-expect-error
export {TodoEmptyStateIcon} from './svg/todo-empty-state-icon';
// @ts-expect-error
export {TodoErrorStateIcon} from './svg/todo-error-state-icon';
// @ts-expect-error
export {TranscribeIcon} from './svg/transcribe-icon';
// @ts-expect-error
export {TrashEmptyIcon} from './svg/trash-empty-icon';
// @ts-expect-error
export {TrashIcon} from './svg/trash-icon'; // Use TrashRegularIcon instead
export {TrashRegularIcon} from './svg/trash-regular-icon';
export {TrophyIcon} from './svg/trophy-icon';
export {TripleChevronIcon} from './svg/triple-chevron-icon';
// @ts-expect-error
export {TVRetroIcon} from './svg/tv-retro-icon';
// @ts-expect-error
export {UnlockIcon} from './svg/unlock-icon';
// @ts-expect-error
export {UnloggedIcon} from './svg/unlogged-icon';
export {UndoRegularIcon} from './svg/undo-regular-icon';
// @ts-expect-error
export {UnpinIcon} from './svg/unpin-icon';
export {UnskipArrowIcon} from './svg/unskip-arrow-icon';
// @ts-expect-error
export {UpgradeArrowIcon} from './svg/upgrade-arrow-icon';
export {UpgradeArrowIconNewNav} from './svg/upgrade-arrow-icon-new-nav';
export {UserIcon} from './svg/user-icon';
export {UserOutlineIcon} from './svg/user-outline-icon';
// @ts-expect-error
export {UserGroupIcon} from './svg/user-group-icon';
export {UserDigestRegularAiIcon} from './svg/user-digest-regular-ai-icon';
// @ts-expect-error
export {VerticalDotsIcon} from './svg/vertical-dots-icon';
export {VideoCameraRegularIcon} from './svg/video-camera-regular-icon';
export {ViewExploreIcon} from './svg/view-explore-icon';
export {ViewListIcon} from './svg/view-list-icon';
// @ts-expect-error
export {VirtualMeetingIcon} from './svg/virtual-meeting-icon';
export {VisitorIqIcon} from './svg/visitor-iq-icon';
// @ts-expect-error
export {VoicemailIcon} from './svg/voicemail-icon';
export {WarningIcon} from './svg/warning-icon';
export {WarningRegularIcon} from './svg/warning-regular-icon';
export {WebFormIcon} from './svg/web-form-icon';
export {WhatsAppIcon} from './svg/whatsapp-icon';
export {WorldRegularIcon} from './svg/world-regular-icon';
export {XSocialIcon} from './svg/x-social-icon';
export {WrenchRegularIcon} from './svg/wrench-regular-icon';
// @ts-expect-error
export {ZoomIcon} from './svg/zoom-icon';
export {ZoomRegularAiIcon} from './svg/zoom-regular-ai-icon';
export {ZoomRegularIcon} from './svg/zoom-regular-icon';
// @ts-expect-error
export {ZoomTextIcon} from './svg/zoom-text-icon';

// Font Awesome Icons
export const AsteriskIcon = faIconCreator('asterisk');
export const BoltIcon = faIconCreator('bolt');
export const CaretDown = faIconCreator('caret-down');
export const CaretRight = faIconCreator('caret-right');
export const CaretUp = faIconCreator('caret-up');
export const CheckIcon = faIconCreator('check');
export const ChevronDownIcon = faIconCreator('chevron-down');
export const ChevronLeftIcon = faIconCreator('chevron-left');
export const ChevronRightIcon = faIconCreator('chevron-right');
export const ChevronUpIcon = faIconCreator('chevron-up');
export const ClockIcon = faIconCreator('clock-o');
export const CloudDownloadIcon = faIconCreator('cloud-download');
export const CloudUploadIcon = faIconCreator('cloud-upload');
export const CogsIcon = faIconCreator('cogs');
export const CreditCardIcon = faIconCreator('credit-card');
export const DescriptionIcon = faIconCreator('align-left');
export const DollarSymbolIcon = faIconCreator('usd');
export const EditIcon = faIconCreator('edit');
export const ErrorCircleIcon = faIconCreator('exclamation-circle');
export const ErrorTriangleIcon = faIconCreator('exclamation-triangle');
export const FrownIcon = faIconCreator('frown-o');
export const GlobeIcon = faIconCreator('globe');
export const HashtagIcon = faIconCreator('hashtag');
export const KeyIcon = faIconCreator('key');
export const LockIcon = faIconCreator('lock');
export const MicrophoneSlashIcon = faIconCreator('microphone-slash');
export const MinimizeIcon = faIconCreator('window-minimize');
export const MinusCircleIcon = faIconCreator('minus-circle');
export const PaperPlane = faIconCreator('paper-plane');
export const Pencil = faIconCreator('pencil'); // use PencilOutlineIcon instead
export const PhoneIcon = faIconCreator('phone'); // Use PhoneRegularIcon instead
export const PlayIcon = faIconCreator('play');
export const PlusIcon = faIconCreator('plus');
export const RepeatIcon = faIconCreator('repeat');
export const RocketIcon = faIconCreator('rocket');
export const SearchIcon = faIconCreator('search');
export const ShareIcon = faIconCreator('share');
export const SignOutIcon = faIconCreator('sign-out');
export const SpinnerIcon = faIconCreator('spinner fa-spin');
export const StarIcon = faIconCreator('star');
export const TimesCircleIcon = faIconCreator('times-circle');
export const TimesIcon = faIconCreator('times');
export const UsersIcon = faIconCreator('users');
export const WandIcon = faIconCreator('magic');
